import React, {
    useState,
    useEffect,
    useRef,
    forwardRef,
    useImperativeHandle,
} from 'react';
import { useNavigate } from 'react-router-dom';
import Spinner from '../ui/spinners/Spinner';
import ThemeForm from './ThemeForm';
import styles from './AgencyPage.module.scss';
import { ROUTES } from '../../constants/routes';
import { getText } from '../../i18n';

const ThemeTab = forwardRef(({ agencyId, agencyRecord, onSave }, ref) => {
    const navigate = useNavigate();
    const [themeData, setThemeData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const themeFormRef = useRef();

    useEffect(() => {
        try {
            setIsLoading(true);
            setThemeData(agencyRecord || {});
            setError(null);
        } catch (error) {
            console.error('Error retrieving agency theme data:', error);
            setError('Could not fetch theme data. Please try again later.');
        } finally {
            setIsLoading(false);
        }
    }, [agencyId, agencyRecord]);

    const onReturnToList = () => {
        navigate(ROUTES.AGENCIES);
    };

    const handleCancelClick = () => {
        onReturnToList();
    };

    useImperativeHandle(ref, () => ({
        handleSave,
    }));

    const handleSave = async options => {
        if (!themeFormRef.current) {
            return { success: false };
        }

        return themeFormRef.current.handleSave(options);
    };

    if (error) {
        return <p>{error}</p>;
    }

    if (!themeData) {
        return <p>{getText('msg_61370d8682c3')}</p>;
    }

    return (
        <>
            {isLoading ? (
                <Spinner width={50} className={styles.loadingSpinner} />
            ) : (
                <div className={styles.themeTab}>
                    <ThemeForm
                        ref={themeFormRef}
                        agencyId={agencyId}
                        initialData={themeData}
                        onSave={onSave}
                        onCancel={handleCancelClick}
                        // NOTE: ThemeForm derives create mode from initialData.id == -1
                        // so this prop isn't needed (and ThemeForm doesn't consume it anyway).
                    />
                </div>
            )}
        </>
    );
});

export default ThemeTab;
